/* eslint-disable */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatutilityRoleService extends BaseService {
  constructor() {
    super(constants.GET_USER_ROLES_TENANT, 'tenantUserRolesStatus');
  }

  handleEvent(eventName, event) {
    const headers = utils.buildHeadersWithTenantId(event);
    if (event) {
      return this.getClient('aiadmin').get(`/users/roles`, { headers });
    }
  }

  handleResponse(response) {
    // eslint-disable-line class-methods-use-this
    Framework.getStoreRegistry().getStore('chatutilityuserRoles').set(response.data);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    }
  }
}
